export default function ChatbotLoader() {
  return (
    <div className="typing">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
}
